export default "__VITE_ASSET__BKedweMC__";